export const HUB_IMPLEMENTATION = {
    TERMS_AND_CONDITIONS_ADDED: 'terms_and_conditions_added',
    PRODUCT_CATALOG_CREATED: 'product_catalog_created', // Waiting for product seeding refactor
    PRODUCTS_ADDED: 'products_added', // Waiting for product seeding refactor
    DISCOUNT_CODES_CREATED: 'discount_codes_created',
    ADMIN_META_OAUTH_SUCCESS: 'admin_meta_oauth_success',
    ADMIN_ACCOUNT_ADDED: 'admin_account_added',
    ADMIN_USER_ADDED: 'admin_user_added',
};

export const AMBASSADOR_RECRUITMENT = {
    AMBASSADOR_LIST_UPLOADED: 'ambassador_list_uploaded',
    AMBASSADOR_APPLICATION_RECEIVED: 'ambassador_application_received',
    AMBASSADOR_APPLICATION_REJECTED: 'ambassador_application_rejected',
    AMBASSADOR_APPLICATION_APPROVED: 'ambassador_application_approved',
    AMBASSADOR_META_OAUTH_SUCCESS: 'ambassador_meta_oauth_success',
    AMBASSADOR_META_OAUTH_FAILURE: 'ambassador_meta_oauth_failure',
    AMBASSADOR_DISCOUNT_CODE_ASSIGNED: 'ambassador_discount_code_assigned',
    AMBASSADOR_PRODUCT_SEEDED: 'ambassador_product_seeded', // Waiting for product seeding refactor
    AMBASSADOR_GROUP_CREATED: 'ambassador_group_created',
    AMBASSADOR_CAMPAIGN_OPT_IN: 'ambassador_campaign_opt_in',
};

export const AMBASSADOR_ACTIVATION = {
    CAMPAIGN_GO_LIVE: 'campaign_go_live',
    CAMPAIGN_POST_COUNT_REPORTED: 'campaign_post_count_reported',
    // CAMPAIGN_POST_SUBMISSION_RECEIVED: 'campaign_post_submission_received',
    // CAMPAIGN_POST_SUBMISSION_APPROVED: 'campaign_post_submission_approved',
};

export const COMMUNITY_MESSAGING = {
    CAMPAIGN_MESSAGE_SENT: 'campaign_message_sent',
    COMMUNITY_MESSAGE_SENT: 'community_message_sent',
    GROUP_MESSAGE_SENT: 'group_message_sent',
    DIRECT_MESSAGE_SENT: 'direct_message_sent',
    CONTENT_APPROVAL_MESSAGE_SENT: 'content_approval_message_sent',
};

export const SALES_AND_PAYMENTS = {
    PAYMENT_APPROVED: 'payment_approved',
    TOTAL_SALES_REPORTED: 'total_sales_reported',
};

export const CLIENT_ENGAGEMENT = {
    CUSTOMER_LOGIN: 'customer_login',
    CS_LOGIN: 'cs_login',
    USER_LOGIN: 'user_login',
};
